import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PickingJobDetailQueryVariables = Types.Exact<{
  picking_job_id: Types.Scalars['ID'];
}>;


export type PickingJobDetailQuery = { __typename?: 'Query', getPickingJob?: { __typename?: 'PickingJob', id: string, segment: Types.PickingJobSegment, status: Types.PickingJobStatus, carrier_pickup_date?: string | null, carrier_delivery_date?: string | null, total_weight?: number | null, pallet_count?: number | null, package_count?: number | null, carrier_employee_comment?: string | null, created_at: string, updated_at: string, delivery_confirmed_at?: string | null, has_booked_or_delivered_rows: boolean, delivery_confirmed_by?: { __typename?: 'IdName', id: string, name: string } | null, resolution?: { __typename?: 'PickingJobResolution', destination: Types.PickingJobResolutionDestination, resolved_at: string, reason: string, resolved_by?: { __typename?: 'IdName', id: string, name: string } | null } | null, item_location_warehouse: { __typename?: 'IdName', id: string, name: string }, destination: { __typename?: 'PickingJobDestination', partner_name?: string | null, event?: { __typename?: 'PickingJobEvent', id: string, name?: string | null } | null, drop_off_location?: { __typename?: 'IdName', id: string, name: string } | null }, items: Array<{ __typename?: 'PickingJobItem', id: string, type_name: string, amount_ordered: number, amount_picked: number, amount_delivered: number, is_over_picked: boolean }>, ops_orders: Array<{ __typename?: 'PickingJobOpsOrder', id: string, status: Types.MerchantOrderStatusEnum, ops_comment?: string | null, owned_by_job: boolean }> } | null };


export const PickingJobDetailDocument = gql`
    query PickingJobDetail($picking_job_id: ID!) {
  getPickingJob(picking_job_id: $picking_job_id) {
    id
    segment
    status
    carrier_pickup_date
    carrier_delivery_date
    total_weight
    pallet_count
    package_count
    carrier_employee_comment
    created_at
    updated_at
    delivery_confirmed_at
    delivery_confirmed_by {
      id
      name
    }
    resolution {
      destination
      resolved_at
      resolved_by {
        id
        name
      }
      reason
    }
    has_booked_or_delivered_rows
    item_location_warehouse {
      id
      name
    }
    destination {
      event {
        id
        name
      }
      partner_name
      drop_off_location {
        id
        name
      }
    }
    items {
      id
      type_name
      amount_ordered
      amount_picked
      amount_delivered
      is_over_picked
    }
    ops_orders {
      id
      status
      ops_comment
      owned_by_job
    }
  }
}
    `;

/**
 * __usePickingJobDetailQuery__
 *
 * To run a query within a React component, call `usePickingJobDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickingJobDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickingJobDetailQuery({
 *   variables: {
 *      picking_job_id: // value for 'picking_job_id'
 *   },
 * });
 */
export function usePickingJobDetailQuery(baseOptions: Apollo.QueryHookOptions<PickingJobDetailQuery, PickingJobDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickingJobDetailQuery, PickingJobDetailQueryVariables>(PickingJobDetailDocument, options);
      }
export function usePickingJobDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickingJobDetailQuery, PickingJobDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickingJobDetailQuery, PickingJobDetailQueryVariables>(PickingJobDetailDocument, options);
        }
export type PickingJobDetailQueryHookResult = ReturnType<typeof usePickingJobDetailQuery>;
export type PickingJobDetailLazyQueryHookResult = ReturnType<typeof usePickingJobDetailLazyQuery>;
export type PickingJobDetailQueryResult = Apollo.QueryResult<PickingJobDetailQuery, PickingJobDetailQueryVariables>;